// extracted by mini-css-extract-plugin
export var askAiIcon = "_kq-9";
export var container = "_kq-0";
export var groupSeparator = "_kq-a";
export var highlight = "_kq-4";
export var resultIcon = "_kq-5";
export var resultItem = "_kq-7";
export var resultSubtitle = "_kq-3";
export var resultTitle = "_kq-2";
export var resultsList = "_kq-1";
export var searchGroup = "_kq-6";
export var selected = "_kq-8";